<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'MpkProjectStatuses',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Статус проекта',
        canEdit: true,
        apiRoute: 'mpkprojectstatus',
        cardName: 'MpkProjectStatusCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
